import { render } from "./Voltage.vue?vue&type=template&id=18780c64&scoped=true&ts=true"
import script from "./Voltage.vue?vue&type=script&lang=ts"
export * from "./Voltage.vue?vue&type=script&lang=ts"

import "./Voltage.vue?vue&type=style&index=0&id=18780c64&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18780c64"]])

export default __exports__